import React, { useState } from "react";
import "./TalentAcademiesContent.css";
import Modal from "react-modal";

function TalentAcademiesContent(props) {
  const [talentVal, setTalentVal] = useState("t_talent");
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState("");

  React.useEffect(() => {
    setTalentVal(props.menu2);
  }, [props.menu2]);

  const handleOpenModal = (val) => {
    setActiveModal(val);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal("");
  };
  return (
    <>
      <div className="whatsnew-container">
        <div className="whatsnew-wrap">
          <div className="whatsnew-row row2">
            

            <div className="whatsnew-box">
              <div class="tab-content" id="v-pills-tabContent-2">
                <div className="whats-container">
                  <div className="whats-wrap">
                  <div
                      className={
                        props.menu3 === "Atrias"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3 role="heading" aria-level="2">Atrias</h3>
                        <p>
                        Welcome to Atrias Academy! It's a one-stop comprehensive platform for Technical as well as process training needs of Atrias
                        </p>
                        <p>
                          <a
                            href="mailto:LKM.AtriasAcademy" aria-label="mailto:LKM.AtriasAcademy"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm.accenture.com/AtriasTalentAcademy/"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    
                    <div
                      className={
                        props.menu3 === "Nordea"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3 role="heading" aria-level="2">Barclays</h3>
                        <p>
                        Barclays aims to effectively upskill/multi skill/cross-skill their resources to meet their growing needs
                        </p>
                        <p>
                          <a
                            href="mailto:LKM.BarclaysAcademy" aria-label="mailto:LKM.BarclaysAcademy"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm.accenture.com/BarclaysAcademy/"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <div
                      className={
                        props.menu3 === "Nordea"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3 role="heading" aria-level="2">Nordea</h3>
                        <p>
                        Welcome to Nordea Talent Academy! It's a one-stop comprehensive platform for faster infusion into Nordea's ways of working
                        </p>
                        <p>
                          <a
                            href="mailto:LKM.NordeaAcademy" aria-label="mailto:LKM.NordeaAcademy"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm.accenture.com/NordeaAcademy/"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    <div
                      className={
                        props.menu3 === "Nordea"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3 role="heading" aria-level="2">Relex</h3>
                        <p>
                        Relex's supply chain management software is designed to help businesses optimize their inventory levels, improve demand forecasting accuracy, and streamline their operations
                        </p>
                        <p>
                          <a
                            href="mailto:LKM.RelexAcademy" aria-label="mailto:LKM.RelexAcademy"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm.accenture.com/RelexAcademy/home"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="whats-wrap">
                  <div
                      className={
                        props.menu3 === "Nordea"
                          ? "whats-row highlight-search"
                          : "whats-row"
                      }
                    >
                      <div className="whats-box">
                        <h3 role="heading" aria-level="2">Shell University</h3>
                        <p>
                        Shell aims to meet the speed and scale aligned with their "Powering Progress strategy" by upskilling/multiskilling/cross-skilling people
                        </p>
                        <p>
                          <a
                            href="mailto:LKM.ShellUniversity" aria-label="mailto:LKM.ShellUniversity"
                            className="left-side-link"
                            target="_blank"
                          >
                            <img
                              src="images/Offerings/mail-icon-normal.png"
                              alt=""
                            />
                          </a>
                          <a
                            className="right-side-link"
                            href="https://atci.lkm.accenture.com/ShellUniversity/"
                            target="_blank"
                          >
                            Explore More{" "}
                            <img
                              src="images/Home/Explore arrow.png"
                              alt=""
                            />
                          </a>
                        </p>
                        <img
                          src="images/Offerings/latest-label-tag.gif"
                          alt="new-label"
                          className="new-label-img"
                        />
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TalentAcademiesContent;
